(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('PavillionDetailController', PavillionDetailController);

    PavillionDetailController.$inject = ['PavillionDetailService', '$log', '$rootScope', '$translate'];

    function PavillionDetailController(PavillionDetailService, $log, $rootScope, $translate) {
        // VARIABLES
        var vm = this;
        vm.lang = $translate.use();
        vm.detail = {};

        load();

        return vm;

        // OTHER
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
        });

        function load() {
            PavillionDetailService.getDetails().then(success, error);
        }

        function success(response) {
            $log.debug('Details loaded:');
            vm.detail = response.data;
            $log.debug(vm.detail);
        }

        function error(response) {
            $log.debug('ERROR:');
            $log.debug(response);
        }

    }
})();
